if (typeof RealFeelV2 !== 'function') {
class RealFeelV2 extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			reviewBlock: '.sequence-block--review',
			reviewTitle: '.block-review__title',
			reviewDate: '.block-review__date',
			reviewAuthor: '.block-review__author',
			reviewBody: '.block-review__body',
			reviewImage: '.block-review__image img',
			modal: '.real-feel-modal',
			modalImage: '.real-feel-modal img',
			modalClose: '.real-feel-modal__close',
			imageBlock: '.sequence-block__image',
			disabledElements: '.element-disabled',
		};

		this.classes = {
			modal: 'real-feel-modal',
			modalVisible: 'real-feel-modal--visible',
			elementDisabled: 'element-disabled',
		};

		this.reviews = JSON.parse(localStorage.getItem('judgeMeReviews')) || [];

		this.addListeners();
		this.init();
	}

	addListeners() {
		document.body.addEventListener('click', (e) => {
			const element = e.target;

			if (element.closest(this.selectors.imageBlock)) {
				this.updateModalImage(element.closest(this.selectors.imageBlock).dataset.originalImg);
				this.disableElement(element.closest(this.selectors.imageBlock));
			}

			if (element.classList.contains(this.classes.modal) || element.closest(this.selectors.modalClose) !== null) {
				this.toggleModal();
			}
		});

		document.querySelector(this.selectors.modalImage).addEventListener('load', () => {
			this.enableAll();
			this.toggleModal();
		});
	}

	disableElement(element) {
		element.style.pointerEvents = 'none';
		element.classList.add(this.classes.elementDisabled);
	}

	enableAll() {
		document.querySelectorAll(this.selectors.disabledElements).forEach((element) => {
			element.style.pointerEvents = 'all';
		});
	}

	async init() {
		if (this.needsApiData()) {
			await this.collectReviews();
		}

		this.populateReviews();
	}

	needsApiData() {
		const localReviewsData = localStorage.getItem('judgeMeReviews');

		if (localStorage.getItem('judgeMeReviews') === null) {
			return true;
		} else {
			const currentTimestamp = Date.now();
			const allowedDifference = 24 * 60 * 60 * 1000; // 24h
			const reviewsTimestamp = +localStorage.getItem('judgeMeReviewsTimestamp');

			if (currentTimestamp - reviewsTimestamp > allowedDifference) {
				return true;
			}
		}

		return false;
	}

	async collectReviews() {
		const shop = 'alienstorecomputers.myshopify.com';
		const apiToken = 'xen0nT04DJuwzhR6S8MxeHrOD6Y';
		const corsServer = 'https://sleepy-atoll-73441.herokuapp.com';
		const apiURL = `${corsServer}/https://judge.me/api/v1/reviews?api_token=${apiToken}&shop_domain=${shop}&rating=5`;

		const header = {
			'Content-Type': 'application/json',
			'Access-Control-Request-Headers': '*',
		};

		try {
			const response = await fetch(apiURL, {
				method: 'GET',
				headers: header,
			});

			if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
			const textData = await response.text();
			const jsonData = textData ? JSON.parse(textData) : {};

			this.reviews = jsonData.reviews || [];
			localStorage.setItem('judgeMeReviewsTimestamp', Date.now());
			localStorage.setItem('judgeMeReviews', JSON.stringify(jsonData.reviews || []));
		} catch (error) {
			console.log('Error fetching reviews:', error);
		}
	}

	async getProductImage(productHandle) {
		const apiURL = `/products/${productHandle}.js`;
		const header = {
			'Content-Type': 'application/json',
			'Access-Control-Request-Headers': '*',
		};

		try {
			const response = await fetch(apiURL, {
				method: 'GET',
				headers: header,
			});

			if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
			const textData = await response.text();
			const jsonData = textData ? JSON.parse(textData) : {};

			return jsonData.featured_image || '';
		} catch (error) {
			console.log('Error fetching product image:', error);
		}
	}

	prettierDate(date) {
		const prettyDate = new Date(date);
		const prettyDay = prettyDate.getDay() < 10 ? `0${prettyDate.getDay()}` : prettyDate.getDay();
		const prettyDateMonth = prettyDate.getMonth() + 1;
		const prettyMonth = prettyDateMonth < 10 ? `0${prettyDateMonth}` : prettyDateMonth;

		return `${prettyDay}/${prettyMonth}/${prettyDate.getFullYear()}`;
	}

	async constructReview(review) {
		const reviewImage =
			review.pictures.length > 0 ? review.pictures[0] : await this.getProductImage(review.product_handle);

		return {
			title: review.title,
			body: review.body,
			productUrl: `/products/${review.product_handle}`,
			date: this.prettierDate(new Date(review.created_at)),
			author: review.reviewer.name,
			image: reviewImage,
		};
	}

	populateReviews() {
		document.querySelectorAll(this.selectors.reviewBlock).forEach(async (block, index) => {
			const review = await this.constructReview(this.reviews[index]);

			block.querySelector(this.selectors.reviewTitle).textContent =
				review.title !== null ? `"${review.title}"` : '';
			block.querySelector(this.selectors.reviewBody).textContent = review.body !== null ? `"${review.body}"` : '';
			block.querySelector(this.selectors.reviewAuthor).textContent = review.author;
			block.querySelector(this.selectors.reviewDate).textContent = review.date;
			block.querySelector(this.selectors.reviewImage).src = review.image;
		});
	}

	updateModalImage(imageSrc) {
		document.querySelector(this.selectors.modalImage).src = imageSrc;
	}

	toggleModal() {
		document.querySelector(this.selectors.modal).classList.toggle(this.classes.modalVisible);
	}
}

	if (!customElements.get('real-feel-v2')) {
        customElements.define('real-feel-v2', RealFeelV2);
    }
}